import { IdiomaService } from './../providers/idioma/idioma.service';
import { Component, EventEmitter, Input, Output, Inject, forwardRef, OnDestroy } from '@angular/core';
import { EntityManagerProvider } from '../providers/entity-manager-provider/entity-manager-provider';
import { AuthenticationService } from '../providers/authentication/authentication.service';
import { TranslateService } from 'ng2-translate';
import { NodoFormulario } from '../domain/NodoFormulario';
import { AppComponent } from '../app.component';

@Component({
  selector: 'app-formulario-posicionar-contenido',
  templateUrl: './FormularioPosicionarContenido.component.html'
})

export class FormularioPosicionarContenidoComponent implements OnDestroy{

	@Input() nodosSeleccionados: any[] = [];
	@Input() msgs: any[];
	@Input() visible: boolean = true;

	@Output() onElementoGuardado: EventEmitter <any> = new EventEmitter();
	@Output() onElementoError: EventEmitter <any> = new EventEmitter();
	@Output() onElementoEliminado: EventEmitter <any> = new EventEmitter();
	@Output() onFormularioValidation: EventEmitter <boolean> = new EventEmitter();

	public isValid = true;
	public color;

	public operacion;

	blockUI: HTMLElement;

	constructor(
		private appComponent: AppComponent,
		private entityManagerProvider: EntityManagerProvider,
		public authService: AuthenticationService,
		public idiomaService: IdiomaService,
		private translate: TranslateService
		) {

				this.blockUI = document.getElementsByClassName('blockPosicionarContenido')[0] as HTMLElement;
				if (this.blockUI) {
					// this.blockUI.style.display = 'inherit';
					this.blockUI.style.display = 'none';
				}
	}

	ngOnDestroy(): void {
		this.entityManagerProvider.RejectChanges();
	}

	/* Confirmacion */
	mostrarConfirmacion(operacion){
		this.appComponent.showWarn(operacion);
		this.operacion = operacion;
	}

	aplicar(){
		this.blockUI = document.getElementsByClassName('blockPosicionarContenido')[0] as HTMLElement;
		this.blockUI.style.display = 'inherit';
		this.authService.relogin();

	}

	posicionar(){
		this.blockUI = document.getElementsByClassName('blockPosicionarContenido')[0] as HTMLElement;
		this.blockUI.style.display = 'none';
	}

	cancelar(){
		this.msgs = [];
		this.operacion = '';
		this.authService.relogin();
	}

}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/formularios/FormularioPosicionarContenido.component.ts